import React from 'react'
import styled from 'styled-components'
import { Asset } from '../AssetOverview.types'
import { AssetCard } from './AssetCard'

const List = styled.div`
	display: flex;
	gap: 10px;
	flex-direction: column;
`

export const AssetCategoryList: React.FC<{
	assets: Asset[]
	onChange: (asset: Asset) => void
	onDelete: (asset: Asset) => void
	shouldInputCooperativeHomeValue?: boolean
}> = ({ assets, onDelete, onChange, shouldInputCooperativeHomeValue }) => (
	<List>
		{assets.map((a) => (
			<AssetCard
				asset={a}
				key={a.id}
				onChange={onChange}
				onDelete={onDelete}
				shouldInputCooperativeHomeValue={shouldInputCooperativeHomeValue}
			/>
		))}
	</List>
)
